<template>
  <div class="d-flex flex-column">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="sales"
      :filtersValue="filtersValue"
      :sort="sort"
      :date="date"
      :externalFilters="pageSize"
    ></filtered-data>

    <div class="container-fluid">
      <div class="d-flex align-items-center">
        <h1 class="mr-auto">Продажи</h1>
        <select v-model="pageSize" class="custom-select mr-2" style="max-width: 6em;">
          <option v-for="size in pageSizes" :value="size">{{size}}</option>
        </select>
        <btn-filters
          :data="data"
          endpoint="sales"
          v-model="filtersValue"
          :range="true"
          :date.sync="date"
        ></btn-filters>
      </div>
    </div>

    <data-table-full-height
      v-if="data && data.data"
      :data="data.data"
      @sort-change="sortChange"
      :default-sort = "{prop: 'sum', order: 'descending'}"
      show-summary
    >
      <table-column-serial-number :fixed="true"/>
      <table-column-string prop="address" label="Адрес установки" :show-overflow-tooltip="true" min-width="275" tableColumnType="string"/>

      <table-column-number align="right" sortable="custom" prop="count" label="Всего" min-width="65" max-width="70" currencySymbol="шт." tableColumnType="number"/>
      <table-column-number align="right" sortable="custom" prop="cash" label="Наличные" min-width="90" max-width="95" currencySymbol="шт." tableColumnType="number"/>
      <table-column-number align="right" sortable="custom" prop="cashless" label="Безнал" min-width="70" max-width="75" currencySymbol="шт." tableColumnType="number"/>
      <table-column-number align="right" sortable="custom" prop="free" label="Бесплатных" min-width="100" max-width="105" currencySymbol="шт." tableColumnType="number"/>
      <table-column-number align="right" sortable="custom" prop="test" label="Тестовых" min-width="80" max-width="85" currencySymbol="шт." tableColumnType="number"/>
      <table-column-number align="right" sortable="custom" prop="token" label="За жетоны" min-width="90" max-width="95" currencySymbol="шт." tableColumnType="number"/>
      <table-column-number align="right" sortable="custom" prop="gateway" label="Удалённые" min-width="95" max-width="100" currencySymbol="шт." tableColumnType="number"/>
      <table-column-number align="right" sortable="custom" prop="sum_cash" label="Сумма налич" min-width="110" max-width="115" currencySymbol="руб." tableColumnType="number"/>
      <table-column-number align="right" sortable="custom" prop="sum_cashless" label="Сумма безнал" min-width="115" max-width="120" currencySymbol="руб." tableColumnType="number"/>
      <table-column-number align="right" sortable="custom" prop="sum" label="Сумма общая" min-width="110" max-width="115" currencySymbol="руб." tableColumnType="number"/>
      <table-column-number align="right" sortable="custom" prop="encashment" label="Инкассировано" min-width="124" max-width="125" currencySymbol="руб." tableColumnType="number"/>

      <table-column-date prop="last_sale_at" label="Последняя продажа" align="right" tableColumnType="date"/>
    </data-table-full-height>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    metaInfo: {title: 'Продажи'},
    data () {
      return {
        filtersValue: null,
        data: {},
        sort: null,
        date: {
          min: moment().subtract(7, 'days').format('YYYY-MM-DD'),
          max: moment().format('YYYY-MM-DD'),
        },
        pageSizes: [100, 250, 500, 1000],
        pageSize: 100,
      }
    },
    methods: {
      sortChange (sort) {
        if (sort.prop) {
          const order = sort.order === 'ascending' ? 'asc' : 'desc'
          this.sort = `${sort.prop}:${order}`
        } else {
          this.sort = null
        }
      },
    },
  }
</script>

<style>
.el-table__footer .cell{
  white-space: nowrap;
  overflow: visible;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/reports/sales.vue